export default function filterUsers (records, filterText, recordType) {
  if (!filterText) {
    return records
  } else if (recordType === 'school' || recordType === 'district' || recordType === 'class') {
    return records.filter((record) => {
      return record.name.toLowerCase().indexOf(filterText.toLowerCase()) > -1
    })
  } else {
    return records.filter((record) => {
      return record.fullName.toLowerCase().indexOf(filterText.toLowerCase()) > -1
    })
  }
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/filterUsers.js